/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserAddress200ResponseAllOfData } from './GetUserAddress200ResponseAllOfData';
import {
    GetUserAddress200ResponseAllOfDataFromJSON,
    GetUserAddress200ResponseAllOfDataFromJSONTyped,
    GetUserAddress200ResponseAllOfDataToJSON,
} from './GetUserAddress200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserAddress200ResponseAllOf
 */
export interface GetUserAddress200ResponseAllOf {
    /**
     * 
     * @type {GetUserAddress200ResponseAllOfData}
     * @memberof GetUserAddress200ResponseAllOf
     */
    data: GetUserAddress200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetUserAddress200ResponseAllOf interface.
 */
export function instanceOfGetUserAddress200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetUserAddress200ResponseAllOfFromJSON(json: any): GetUserAddress200ResponseAllOf {
    return GetUserAddress200ResponseAllOfFromJSONTyped(json, false);
}

export function GetUserAddress200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserAddress200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserAddress200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetUserAddress200ResponseAllOfToJSON(value?: GetUserAddress200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserAddress200ResponseAllOfDataToJSON(value.data),
    };
}

